export enum NonSsoSignInMethod {
  EMAIL_AND_PASSWORD = 'emailAndPassword',
  EMAIL_LINK = 'emailLink',
}
